import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { parse } from 'query-string';
import { func } from 'prop-types';
import { startSetMyOffers } from '../../actions/webmaster';
import { startEditDomain, startSetDomain, startSetDomainOffer } from '../../actions/domains';
import { startSetStreams } from '../../actions/streams';
import Layout from '../../components/Layout/Layout';
import DomainForm from '../../components/Domains/DomainForm/DomainForm';
import WithAlert from '../../hoc/WithAlert';
import { animatedScrollTo } from '../../utils/utils';
import { iFMessage } from '../../hoc/IntlComponents';

class DomainPage extends Component {
  static propTypes = {
    startEditDomain: func.isRequired,
    startSetDomain: func.isRequired,
    startSetMyOffers: func.isRequired,
    startSetDomainOffer: func.isRequired,
  };

  state = {
    loading: false,
    error: null,
  };

  componentDidMount() {
    const { match, history, intl } = this.props;
    const params = parse(history.location.search);

    if (params.created) {
      this.props.showAlert({
        alertType: 'success',
        message: iFMessage({ intl, id: 'domain.created' }),
        dismissable: false,
        closeInSeconds: 3,
      });
    }

    if (match.params && match.params.id) {
      const { id, type } = match.params;

      this.setState(() => ({ loading: true }));
      this.props
        .startSetDomain(id, type)
        .then(() => (type !== 'tracking' && type !== 'tds' ? this.props.startSetMyOffers() : null))
        .then(() => (type === 'tds' ? this.props.startSetStreams() : null))
        .then(() => this.setState(() => ({ loading: false })))
        .catch(err => {
          this.setState(() => ({ loading: false }));
        });
    }
  }

  handleOfferChange = offerId => {
    this.setState(() => ({ loading: true }));
    this.props.startSetDomainOffer(offerId).then(() => this.setState(() => ({ loading: false })));
  };

  handleSubmit = (domain = {}) => {
    const { intl } = this.props;
    this.setState(() => ({ loading: true }));

    const { id, type } = domain;

    const updates = {
      domain: domain.domain,
      landingId:
        type === 'landing' ? domain.landings : type === 'prelander' ? domain.prelanders : undefined,
      offerId: type !== 'tds' ? domain.offerId : undefined,
      tdsId: type === 'tds' ? domain.tdsId : undefined,
      title: type === 'tds' ? domain.title : undefined,
    };

    animatedScrollTo(null, 600, 80);

    this.props
      .startEditDomain(id, type, updates)
      .then(({ id }) => {
        this.setState(() => ({ loading: false }));

        this.props.showAlert({
          alertType: 'success',
          message: iFMessage({ intl, id: 'domain.saved' }),
          dismissable: false,
          closeInSeconds: 3,
        });
      })
      .catch(({ response }) => {
        if (response && response.data && response.data.error) {
          const { message: error } = response.data.error;
          this.setState(() => ({ loading: false, error }));
        }
      });
  };

  render() {
    const { loading, error } = this.state;

    return (
      <Layout formattedTitle="domains.breadcrumb">
        <Layout.Col>
          <DomainForm
            isEdit
            loading={loading}
            onSubmit={this.handleSubmit}
            onOfferChange={this.handleOfferChange}
          />
        </Layout.Col>

        {error && error.message && (
          <AlertModal open message={error.message} onClose={this.handleModalClose} />
        )}
      </Layout>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  startEditDomain: (id, type, updates) => dispatch(startEditDomain(id, type, updates)),
  startSetDomain: (id, type) => dispatch(startSetDomain(id, type)),
  startSetMyOffers: () => dispatch(startSetMyOffers()),
  startSetDomainOffer: offerId => dispatch(startSetDomainOffer(offerId)),
  startSetStreams: params => dispatch(startSetStreams(params)),
});

export default connect(
  null,
  mapDispatchToProps,
)(WithAlert(injectIntl(DomainPage)));
